import type {
  CheckboxOperator,
  DateOperator,
  DateTimeOperator,
  FilterType,
  NumberOperator,
  SelectOperator,
  TagOperator,
  TextOperator,
  TimeOperator,
} from '../types/filter-meta';

export const SELECT_OPERATOR_LABELS = {
  anyOf: 'is any of',
  noneOf: 'is none of',
  isEmpty: 'is empty',
} satisfies Record<SelectOperator, string>;

export const TAG_OPERATOR_LABELS = {
  anyOf: 'is any of',
  noneOf: 'is none of',
  isEmpty: 'is empty',
} satisfies Record<TagOperator, string>;

export const TEXT_OPERATOR_LABELS = {
  contains: 'contains',
  equals: 'equals',
  startsWith: 'starts with',
  endsWith: 'ends with',
  isEmpty: 'is empty',
} satisfies Record<TextOperator, string>;

export const NUMBER_OPERATOR_LABELS = {
  eq: 'equals',
  gt: 'is greater than',
  gte: 'is at least',
  lt: 'is less than',
  lte: 'is at most',
  between: 'is between',
  isEmpty: 'is empty',
} satisfies Record<NumberOperator, string>;

export const CURRENCY_OPERATOR_LABELS = NUMBER_OPERATOR_LABELS;

export const DATE_OPERATOR_LABELS = {
  eq: 'is',
  before: 'is before',
  after: 'is after',
  between: 'is between',
  isEmpty: 'is empty',
} satisfies Record<DateOperator, string>;

export const TIME_OPERATOR_LABELS = {
  eq: 'is',
  before: 'is before',
  after: 'is after',
  between: 'is between',
  isEmpty: 'is empty',
} satisfies Record<TimeOperator, string>;

export const DATETIME_OPERATOR_LABELS = {
  eq: 'is',
  before: 'is before',
  after: 'is after',
  between: 'is between',
  isEmpty: 'is empty',
} satisfies Record<DateTimeOperator, string>;

export const CHECKBOX_OPERATOR_LABELS = {
  is: 'is',
  isNot: 'is not',
} satisfies Record<CheckboxOperator, string>;

export const DEFAULT_OPERATORS = {
  select: ['anyOf'],
  tag: ['anyOf'],
  text: ['contains'],
  number: ['between'],
  currency: ['between'],
  date: ['between'],
  time: ['between'],
  datetime: ['between'],
  checkbox: ['is'],
} satisfies Record<FilterType, readonly string[]>;

export const OPERATOR_LABELS_BY_TYPE = {
  select: SELECT_OPERATOR_LABELS,
  tag: TAG_OPERATOR_LABELS,
  text: TEXT_OPERATOR_LABELS,
  number: NUMBER_OPERATOR_LABELS,
  currency: CURRENCY_OPERATOR_LABELS,
  date: DATE_OPERATOR_LABELS,
  time: TIME_OPERATOR_LABELS,
  datetime: DATETIME_OPERATOR_LABELS,
  checkbox: CHECKBOX_OPERATOR_LABELS,
} satisfies Record<FilterType, Record<string, string>>;
